import { FC, memo } from 'react'
import { Box, useToken, useColorModeValue } from '@chakra-ui/react'

type Props = {
  size?: number
}

const AppCitizenModuleBrand: FC<Props> = ({ size = 12 }) => {
  const [primary200, primary300, primary400, primary500, primary600, primary700, primary900, white] = useToken('colors', [
    'primary.200',
    'primary.300',
    'primary.400',
    'primary.500',
    'primary.600',
    'primary.700',
    'primary.900',
    'white',
  ])

  const strokeColor900 = useColorModeValue(primary900, primary900)
  const strokenWidth = '40px'
  const fillColor200 = useColorModeValue(primary200, primary300)
  const fillColor400 = useColorModeValue(primary400, primary500)
  const fillColor600 = useColorModeValue(primary600, primary700)
  const fillBG = useColorModeValue(white, white)

  return (
    <Box w={size} h={size} pos="relative">
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 800 800">
        <g id="App_Cidadão" data-name="App Cidadão">
          <g id="background">
            <g id="group200">
              <path
                fill={fillColor200}
                opacity="0.25"
                d="M171.65,494.08c7.56,92.08,63.95,177,155.17,215.56,121.87,51.49,265.12-.45,327.5-118.82.42-.79.83-1.58,1.24-2.38,17.05-33.14,41.7-61.48,71.23-84.07a156.13,156.13,0,0,0,49.05-63.55c32.54-77-2.06-166.79-77.3-201-29.15-13.26-102.27-18.13-158.4-20.81-37.84-1.82-71.86-22.65-91.47-55.15A201.9,201.9,0,0,0,348.43,79.62c-97.12-37.81-209,5.58-256.95,99.46C46.79,266.62,69.69,369.5,139.25,429.54A95.42,95.42,0,0,1,171.65,494.08Z"
              />
            </g>
            <g id="group400">
              <path
                fill={fillColor400}
                opacity="0.2"
                d="M635,210.89c5.21-36.46-9.18-74.47-41.23-97.53C551,82.55,490.66,90.06,455.93,130.54l-.69.82a99.81,99.81,0,0,1-35.14,26.37,62.36,62.36,0,0,0-24.69,20.36c-19.47,27-14,65,12.25,85,10.15,7.74,38.15,16.11,59.73,22.12,14.55,4.06,24.63,10.73,29.37,25.11,5.39,16.33,29.61,35.72,51.73,34.68,41.5-2,48.82-11.24,76.65-42.73,12.48-14.12,33.39-26.5,11.67-56C630.92,238.26,633.57,220.8,635,210.89Z"
              />
              <path
                fill={fillColor400}
                opacity="0.2"
                d="M308.81,559.56C297,594.44,304.17,634.45,331.44,663c36.43,38.14,97.07,41.82,138.64,8.4l.83-.68a99.88,99.88,0,0,1,39.38-19.47,62.25,62.25,0,0,0,28-15.49c24.1-23,25.66-61.35,3.56-85.78-8.57-9.47-34.55-22.84-54.66-32.71-13.56-6.65-22.24-15.07-24.27-30.06-2.3-17.06-22.55-40.56-44.48-43.59-41.16-5.69-50.06,2.08-83.19,27.93-14.86,11.6-37.69,19.93-21.76,52.91C317.83,533.4,312,550.08,308.81,559.56Z"
              />
              <path
                fill={fillColor400}
                opacity="0.2"
                d="M82.12,283.57C50,301.54,28.47,336,29.56,375.5c1.47,52.73,44,96.11,97.25,99.18l1.07.05a100,100,0,0,1,42.27,11.95A62.36,62.36,0,0,0,201.32,494c33.31-.92,60.17-28.32,60.15-61.27,0-12.77-10.33-40.1-18.64-60.91-5.6-14-6.4-26.09,2.15-38.58,9.73-14.19,10.46-45.2-3.78-62.16-26.73-31.82-38.55-32-80.46-35-18.8-1.36-41.32-10.49-51.61,24.67C106.34,270.21,90.86,278.69,82.12,283.57Z"
              />
            </g>
            <g id="group600">
              <path
                fill={fillColor600}
                d="M158.78,562.67S98.67,510,130.33,424s21.56-33.67,31.11-117.33,90.23-143.56,144.89-159.11,141.45,2.77,171.56,31.11,50.33,68.44,70.22,80.89S654.78,308,677.89,352s21.55,121.11,5.33,147.56-52.55,87.77-128.89,95.11S441.78,553.2,411,549c-44-6-62.33,20.33-96.67,29.67S227.56,622.33,158.78,562.67Z"
              />
              <path
                fill={fillColor600}
                d="M743.34,164.53A29.45,29.45,0,0,0,718,146.36a12.24,12.24,0,0,1-10.81-8.1l-.07-.21a14.54,14.54,0,0,0-27.8,8.29,14.43,14.43,0,0,0,3.41,6.58,19.91,19.91,0,0,1,4.43,17.25,29.48,29.48,0,1,0,56.19-5.64Z"
              />
              <path
                fill={fillColor600}
                d="M64.3,181c-5.49,12.92-26.58,16.31-39.49,10.81S12,174,17.53,161,43,130.3,55.9,135.8,69.8,168,64.3,181Z"
              />
              <path
                fill={fillColor600}
                d="M668.87,89.71a14.89,14.89,0,0,1-20,22.08c-6.1-5.52-18.14-14.36-12.62-20.46S662.78,84.19,668.87,89.71Z"
              />
            </g>
          </g>
          <g id="icon">
            <path
              stroke={strokeColor900}
              strokeWidth={strokenWidth}
              strokeLinecap="round"
              strokeLinejoin="round"
              fill={fillBG}
              d="M565.37,551.72H235.14a25.47,25.47,0,0,1-25.43-25.42V505.68h0A106.7,106.7,0,0,1,316.12,399.31H484.39A106.69,106.69,0,0,1,590.8,505.67V526.3h0A25.47,25.47,0,0,1,565.37,551.72Z"
            />
            <path
              stroke={strokeColor900}
              strokeWidth={strokenWidth}
              strokeLinecap="round"
              strokeLinejoin="round"
              fill={fillBG}
              d="M400.25,348.38h0A102.89,102.89,0,1,1,503.14,245.09h0A103,103,0,0,1,400.48,348.38Z"
            />
          </g>
        </g>
      </svg>
    </Box>
  )
}

export default memo(AppCitizenModuleBrand)
